import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32fb50b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }

import { CloseOutlined } from '@ant-design/icons-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Title',
  emits: ['close'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode("Create support ticket "),
    _createVNode(_unref(CloseOutlined), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
      style: {"color":"var(--color-primary)","margin-left":"20px"}
    })
  ]))
}
}

})